import React from 'react';
import EImg from './EImg';

export default ({ width = 24, height = 24 }) => (
	<EImg
		width={width}
		height={height}
		title="Fire"
		aria-label="Emoji: Fire"
		alt="🔥"
		src="https://abs.twimg.com/emoji/v2/72x72/1f525.png"
	/>
);
